import { config } from "../env";
import {
  Delete,
  DeleteWithPayload,
  get,
  patch,
  post,
} from "./helpers/http-handler";

export const adminCreateCheckpoint = (payload: object) =>
  post(
    `${
      config.API_URL
    }/checkpoint`,
    payload
  );

export const adminGetCheckpoint = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/checkpoint?${queryRequest}`
  );

export const adminGetSpecificCheckpoint = (id: string) =>
  get(
    `${
      config.API_URL
    }/checkpoint/${id}`
  );

export const adminUpdateSpecificCheckpoint = (id: string, payload: object) =>
  patch(
    `${
      config.API_URL
    }/checkpoint/${id}`,
    payload
  );

export const adminDeleteSpecificCheckpoint = (id: string) =>
  Delete(
    `${
      config.API_URL
    }/checkpoint/${id}`
  );

export const adminUpdateBulkStatusCheckpoint = (payload: object) =>
  patch(
    `${
      config.API_URL
    }/checkpoint/bulk/active-inactive`,
    payload
  );

// master -> release to vendor

export const assignCheckpointReleaseVendor = (payload: object) =>
  post(
    `${
      config.API_URL
    }/vendor-checkpoint`,
    payload
  );

export const getCheckpointReleaseVendor = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/vendor-checkpoint?${queryRequest}`
  );

export const vendorCheckpointBulkStatus = (payload: object) =>
  patch(
    `${
      config.API_URL
    }/vendor-checkpoint/bulk/active-inactive`,
    payload
  );

export const DeleteVendorCheckpoint = (payload: object) =>
  DeleteWithPayload(
    `${
      config.API_URL
    }/vendor-checkpoint`,
    payload
  );

// release dates

export const CreateCheckpointReleaseDate = (payload: object) =>
  post(
    `${
      config.API_URL
    }/release-dates`,
    payload
  );

export const GetCheckpointReleaseDate = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/release-dates?${queryRequest}`
  );

export const GetSpecificCheckpointReleaseDate = (id: string) =>
  get(
    `${
      config.API_URL
    }/release-dates/${id}`
  );

export const UpdateSpecificCheckpointReleaseDate = (
  id: string,
  payload: object
) =>
  patch(
    `${
      config.API_URL
    }/release-dates/${id}`,
    payload
  );

export const DeleteSpecificCheckpointReleaseDate = (id: string) =>
  Delete(
    `${
      config.API_URL
    }/release-dates/${id}`
  );

export const UpdateBulkStatusCheckpointReleaseDate = (payload: object) =>
  patch(
    `${
      config.API_URL
    }/release-dates/bulk/active-inactive`,
    payload
  );

export const ReleaseDateAuditCompleted = (payload: object) =>
  post(
    `${
      config.API_URL
    }/release-dates/audit-complete`,
    payload
  );

// PE compliance

export const CreateCheckpointPECompliance = (payload: object) =>
  post(
    `${
      config.API_URL
    }/pe-compliance`,
    payload
  );

export const GetCheckpointPECompliance = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/pe-compliance?${queryRequest}`
  );

export const GetSpecificCheckpointPECompliance = (id: string) =>
  get(
    `${
      config.API_URL
    }/pe-compliance/${id}`
  );

export const UpdateSpecificCheckpointPECompliance = (
  id: string,
  payload: object
) =>
  patch(
    `${
      config.API_URL
    }/pe-compliance/${id}`,
    payload
  );

export const DeleteSpecificCheckpointPECompliance = (id: string) =>
  Delete(
    `${
      config.API_URL
    }/pe-compliance/${id}`
  );

export const UpdateBulkStatusCheckpointPECompliance = (payload: object) =>
  patch(
    `${
      config.API_URL
    }/pe-compliance/bulk/active-inactive`,
    payload
  );

// configure PE compliance

export const ConfigureCheckpointPECompliance = (payload: object) =>
  post(
    `${
      config.API_URL
    }/pe-compliance/configure`,
    payload
  );

// PE compliance task list

export const CreateCheckpointPEComplianceTask = (payload: object) =>
  post(
    `${
      config.API_URL
    }/compliance-task`,
    payload
  );

export const GetCheckpointPEComplianceTask = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/compliance-task?${queryRequest}`
  );

export const GetSpecificCheckpointPEComplianceTask = (id: string) =>
  get(
    `${
      config.API_URL
    }/compliance-task/${id}`
  );

export const GetSpecificCheckpointPEComplianceTaskHistory = (
  id: string,
  queryRequest: string
) =>
  get(
    `${
      config.API_URL
    }/compliance-task/${id}/task-history?${queryRequest}`
  );

export const UpdateSpecificCheckpointPEComplianceTask = (
  id: string,
  payload: object
) =>
  patch(
    `${
      config.API_URL
    }/compliance-task/${id}`,
    payload
  );

export const DeleteSpecificCheckpointPEComplianceTask = (id: string) =>
  Delete(
    `${
      config.API_URL
    }/compliance-task/${id}`
  );

export const UpdateBulkStatusCheckpointPEComplianceTask = (payload: object) =>
  patch(
    `${
      config.API_URL
    }/compliance-task/bulk/active-inactive`,
    payload
  );

// add to tracker

// export

export const exportCheckpointMaster = (payload: object) =>
  post(
    `${
      config.API_URL
    }/reports/export-checkpoint-master`,
    payload
  );

// upload list
export const getVendorCheckpointDocuments = (id: string) =>
  get(
    `${
      config.API_URL
    }/vendor-checkpoint/${id}/list/documents`
  );

export const getVendorCheckpointsAllDocuments = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/reports/vendor-checkpoints/all-documents-zip?${queryRequest}`
  );

export const getDocumentCheckpoint = (payload: object) =>
  post(
    `${
      config.API_URL
    }/checkpoint/get-documents`,
    payload
  );

//Release Dates New API
export const GetCheckpointReleaseDateNew = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/release-dates/vendors?${queryRequest}`
  );

export const GetCheckpointReleaseDateVendorLocation = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/release-dates/vendors/locations?${queryRequest}`
  );

export const CreateReleaseDate = (payload: object) =>
  post(
    `${
      config.API_URL
    }/release-dates`,
    payload
  );

export const GetSpecificLocationHistory = (id: string, queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/release-dates/vendors/locations/${id}/history?${queryRequest}`
  );

export const GetSpecificLocationData = (id: string) =>
  get(
    `${
      config.API_URL
    }/release-dates/vendors/locations/audit-cycles/${id}`
  );

export const EditReleaseDate = (id: string, payload: object) =>
  patch(
    `${
      config.API_URL
    }/release-dates/audit-cycles/${id}`,
    payload
  );

export const GetVendorLocationData = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/vendor-checkpoint/by-location?${queryRequest}`
  );

export const updateVendorUserLocation = (payload: object) =>
  patch(
    `${
      config.API_URL
    }/locations/location/attach`,
    payload
  );

export const GetVendorUserLocation = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/locations/location/attach?${queryRequest}`
  );

export const deleteVendorUserLocation = (payload: object) =>
  DeleteWithPayload(
    `${
      config.API_URL
    }/locations/location/attach`,
    payload
  );

export const ReleaseVendorAuditCompleteBulkUpload = (payload: object) =>
  post(
    `${
      config.API_URL
    }/vendor-checkpoint/bulk/audit-complete`,
    payload
  );

export const ReleaseVendorAuditCompleteUpload = (payload: object) =>
  post(
    `${
      config.API_URL
    }/vendor-checkpoint/audit-complete`,
    payload
  );

export const getSpecificVendorCheckpoint = (id: string) =>
  get(
    `${
      config.API_URL
    }/vendor-checkpoint/${id}`
  );

export const getSpecificVendorCheckpointHistory = (queryRequest: string) =>
  get(
    `${
      config.API_URL
    }/vendor-checkpoint/history?${queryRequest}`
  );
